module.exports = __webpack_public_path__ + "static/media/uwai-logo.d018832b.png";